// ------------------------------------
// Constants
// ------------------------------------
export const ADD_ERRORS = 'inf/signup/ADD_ERRORS'
export const ADVANCE_TO_ACCOUNT = 'inf/signup/ADVANCE_TO_ACCOUNT'
export const ADVANCE_TO_DETAIL = 'inf/signup/ADVANCE_TO_DETAIL'
export const ADVANCE_TO_OFFER = 'inf/signup/ADVANCE_TO_OFFER'
export const ADVANCE_TO_SUMMARY = 'inf/signup/ADVANCE_TO_SUMMARY'
export const AGREE_TERMS = 'inf/signup/AGREE_TERMS'
export const APPLY_COUPON = 'inf/signup/APPLY_COUPON'
export const AUTHENTICATE = 'inf/signup/AUTHENTICATE'
export const BEGIN = 'inf/signup/BEGIN'
export const BEGIN_PARTNER = 'inf/signup/BEGIN_PARTNER'
export const BEGIN_VALIDATION = 'inf/signup/BEGIN_VALIDATION'
export const BEGIN_WORK = 'inf/signup/BEGIN_WORK'
export const CHECKED_EMAIL = 'inf/signup/CHECKED_EMAIL'
export const CHECKING_EMAIL = 'inf/signup/CHECKING_EMAIL'
export const CLEAR_ERRORS = 'inf/signup/CLEAR_ERRORS'
export const CONTINUE_SIGNUP = 'inf/signup/CONTINUE_SIGNUP'
export const DOWNLOAD_PDF = 'inf/signup/DOWNLOAD_PDF'
export const EDIT_SIGNUP = 'inf/signup/EDIT_SIGNUP'
export const END_VALIDATION = 'inf/signup/END_VALIDATION'
export const END_WORK = 'inf/signup/END_WORK'
export const FORGET_ALL_SIGNUPS = 'inf/signup/FORGET_ALL_SIGNUPS'
export const FORGET_SIGNUP = 'inf/signup/FORGET_SIGNUP'
export const LOAD_USER_SIGNUPS = 'inf/signup/LOAD_USER_SIGNUPS'
export const REMEMBER_SIGNUP = 'inf/signup/REMEMBER_SIGNUP'
export const REPLACE_CURRENT_SIGNUP = 'inf/signup/REPLACE_CURRENT_SIGNUP'
export const REVISITING_SIGNUP = 'inf/signup/REVISITING_SIGNUP'
export const QUALIFY_ADDRESS = 'inf/signup/QUALIFY_ADDRESS'
export const SELECT_CLIENT = 'inf/signup/SELECT_CLIENT'
export const SELECT_OFFER = 'inf/signup/SELECT_OFFER'
export const SELECT_TOKEN = 'inf/signup/SELECT_TOKEN'
export const SELECT_USER = 'inf/signup/SELECT_USER'
export const SET_ABN = 'inf/signup/SET_ABN'
export const SET_ADDRESS = 'inf/signup/SET_ADDRESS'
export const SET_ADDRESS_LOCID = 'inf/signup/SET_ADDRESS_LOCID'
export const SET_CARD_NAME = 'inf/signup/SET_CARD_NAME'
export const SET_CARD_NUMBER = 'inf/signup/SET_CARD_NUMBER'
export const SET_CHALLENGE_PHRASE = 'inf/signup/SET_CHALLENGE_PHRASE'
export const SET_COMPANY_NAME = 'inf/signup/SET_COMPANY_NAME'
export const SET_COMPANY_SIZE = 'inf/signup/SET_COMPANY_SIZE'
export const SET_CONTACT = 'inf/signup/SET_CONTACT'
export const SET_COUPON = 'inf/signup/SET_COUPON'
export const SET_CUSTOMER_REFERENCE = 'inf/signup/SET_CUSTOMER_REFERENCE'
export const SET_CVN = 'inf/signup/SET_CVN'
export const SET_DATA = 'inf/signup/SET_DATA'
export const SET_DATE_OF_BIRTH = 'inf/signup/SET_DATE_OF_BIRTH'
export const SET_EMAIL = 'inf/signup/SET_EMAIL'
export const SET_EMAIL_CONFIRM = 'inf/signup/SET_EMAIL_CONFIRM'
export const SET_EXPIRY_MONTH = 'inf/signup/SET_EXPIRY_MONTH'
export const SET_EXPIRY_YEAR = 'inf/signup/SET_EXPIRY_YEAR'
export const SET_EXTRA_OFFER_ID = 'inf/signup/SET_EXTRA_OFFER_ID'
export const SET_FIRST_NAME = 'inf/signup/SET_FIRST_NAME'
export const SET_LAST_NAME = 'inf/signup/SET_LAST_NAME'
export const SET_NEEDS_VOICE = 'inf/signup/SET_NEEDS_VOICE'
export const SET_PARTNER_APPROVED = 'inf/signup/SET_PARTNER_APPROVED'
export const SET_PREFERRED_APPOINTMENT_DATE = 'inf/signup/SET_PREFERRED_APPOINTMENT_DATE'
export const SET_PREFERRED_APPOINTMENT_TIME = 'inf/signup/SET_PREFERRED_APPOINTMENT_TIME'
export const SET_QUALIFICATION = 'inf/signup/SET_QUALIFICATION'
export const SET_QUALIFICATION_RESULT = 'inf/signup/SET_QUALIFICATION_RESULT'
export const SET_SERVICE_PASSWORD = 'inf/signup/SET_SERVICE_PASSWORD'
export const SET_SITE_CONTACT_FIRST_NAME = 'inf/signup/SET_SITE_CONTACT_FIRST_NAME'
export const SET_SITE_CONTACT_LAST_NAME = 'inf/signup/SET_SITE_CONTACT_LAST_NAME'
export const SET_SITE_CONTACT_NUMBER = 'inf/signup/SET_SITE_CONTACT_NUMBER'
export const SET_USE_EXISTING_NUMBER = 'inf/signup/SET_USE_EXISTING_NUMBER'
export const SET_USER_PASSWORD = 'inf/signup/SET_USER_PASSWORD'
export const SUBMIT = 'inf/signup/SUBMIT'
export const SUBMIT_HEARD_ABOUT = 'inf/signup/SUBMIT_HEARD_ABOUT'
export const SUBMIT_MSP = 'inf/signup/SUBMIT_MSP'
export const UPDATE_FILTER = 'inf/signup/UPDATE_FILTER'



// WEBPACK FOOTER //
// ./src/redux/modules/signupEdit/constants.js